import Requester from "./Requester";

interface CreateDTO {
    name: string
    variantType?: string
    variants?: boolean
}

interface UpdateDTO {
    new: Record<number, string>
}

const URL = 'api/series';

export function getSeries(limit: number = 10, page: number = 1, search: string | null = null, options) {
    const requester = new Requester();

    let requestOptions = {}

    if (options !== undefined) {
        requestOptions = {
            ...options
        }
    }

    return requester.get(requester.getUrl(URL, [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
    ]), requestOptions)
}

export function show(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`${URL}/${id}`))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`${URL}/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(URL), values)
}

export function update(id, values: UpdateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`${URL}/${id}`), values)
}

export default {
    create,
    getSeries,
    show,
    update,
    destroy,
}